/**
 * @generated SignedSource<<02c7083aedf2ee3ef63cdb1ecb18391e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lon",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "srcSearchBikeRentalStationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BikeRentalStation",
        "kind": "LinkedField",
        "name": "bikeRentalStations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "srcSearchBikeRentalStationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BikeRentalStation",
        "kind": "LinkedField",
        "name": "bikeRentalStations",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d40ea1631709ef427217251f58c1455",
    "id": null,
    "metadata": {},
    "name": "srcSearchBikeRentalStationsQuery",
    "operationKind": "query",
    "text": "query srcSearchBikeRentalStationsQuery {\n  bikeRentalStations {\n    name\n    stationId\n    lon\n    lat\n    id\n  }\n}\n"
  }
};
})();

node.hash = "7abaa300e148404c39b7ba4a3b977aa7";

module.exports = node;
